"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var HorizontalRule = function HorizontalRule(_ref) {
  var className = _ref.className,
      children = _ref.children,
      lineStyle = _ref.lineStyle,
      position = _ref.position;
  var classes = (0, _classnames.default)('HorizontalRule', "HorizontalRule-".concat(lineStyle), "HorizontalRule-".concat(position), className);
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement("span", null, children));
};

HorizontalRule.propTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** An optional node to render inside of the label. */
  children: _propTypes.default.node,

  /** The line style of the rule. */
  lineStyle: _propTypes.default.oneOf(['solid', 'dashed', 'dotted']),

  /** The position of the node within the rule. */
  position: _propTypes.default.oneOf(['center', 'left', 'right'])
};
HorizontalRule.defaultProps = {
  lineStyle: 'solid',
  position: 'center'
};
var _default = HorizontalRule;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(HorizontalRule, "HorizontalRule", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/HorizontalRule/HorizontalRule.jsx");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/HorizontalRule/HorizontalRule.jsx");
  leaveModule(module);
})();

;